import { isInteger, isValidEmail } from '@togglecorp/fujs';
import { isDefined, isDefinedString, isValidUrl } from './utils.js';

function requiredCondition(value) {
  return !isDefined(value) ? 'The field is required' : undefined;
}
function requiredListCondition(value) {
  return !isDefined(value) || value.length === 0 ? 'The field is required' : undefined;
}
function requiredStringCondition(value) {
  return !isDefinedString(value) ? 'The field is required' : undefined;
}
function blacklistCondition(x) {
  return value => isDefined(value) && x.includes(value) ? `The field cannot be ${value}` : undefined;
}
function whitelistCondition(x) {
  return value => isDefined(value) && !x.includes(value) ? `The field cannot be ${value}` : undefined;
}
function lengthGreaterThanCondition(x) {
  return value => isDefined(value) && value.length <= x ? `Length must be greater than ${x}` : undefined;
}
function lengthSmallerThanCondition(x) {
  // NOTE: isDefinedString is not really required here
  return value => isDefined(value) && value.length >= x ? `Length must be smaller than ${x}` : undefined;
}
function greaterThanCondition(x) {
  return value => isDefined(value) && value <= x ? `Field must be greater than ${x}` : undefined;
}
function smallerThanCondition(x) {
  return value => isDefined(value) && value >= x ? `The field must be smaller than ${x}` : undefined;
}
function greaterThanOrEqualToCondition(x) {
  return value => isDefined(value) && value < x ? `The field must be greater than or equal to ${x}` : undefined;
}
function lessThanOrEqualToCondition(x) {
  return value => isDefined(value) && value > x ? `The field must be smaller than or equal to ${x}` : undefined;
}
function integerCondition(value) {
  return isDefined(value) && !isInteger(value) ? 'The field must be an integer' : undefined;
}
function emailCondition(value) {
  return isDefinedString(value) && !isValidEmail(value) ? 'The field must be a valid email' : undefined;
}
function urlCondition(value) {
  return isDefinedString(value) && !isValidUrl(value) ? 'The field must be a valid url' : undefined;
}

export { blacklistCondition, emailCondition, greaterThanCondition, greaterThanOrEqualToCondition, integerCondition, lengthGreaterThanCondition, lengthSmallerThanCondition, lessThanOrEqualToCondition, requiredCondition, requiredListCondition, requiredStringCondition, smallerThanCondition, urlCondition, whitelistCondition };
//# sourceMappingURL=validation.js.map
